/**
 * Sentinel the filter panel puts in a `cf_*` list to mean "this field has NO
 * value" — no scope row on the lead and none on any of its deals. It travels
 * alongside numeric option ids (`cf_5=12,34,none`); the server recognises the
 * literal and builds a NOT-EXISTS condition. See `resolveCustomFieldFilters`.
 */
export const CF_NONE_SENTINEL = "none";
